module.exports = __webpack_public_path__ + "img/rbs.13392425.svg";